import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const content = {
  ru: {
    heading1: 'СОЗДАЕМ НЕ ПРОСТО ПРОДУКТ,',
    heading2: 'А СТАНДАРТ НОВОЙ ОТДЕЛКИ',
    panelReady: 'Панель готова к установке сразу — без выравнивания, покраски, штукатурки и других "мокрых" процессов.',
    traditional: {
      title: 'Традиционный метод отделки стен',
      subtitle: 'Технологичная альтернатива устаревшим методам отделки',
      desc: 'Мокрые процессы требуют особого контроля качества работ, каждый слой занимает время на просушку. При этом при усадке здания могут появиться трещины, покраска требует регулярного перекрашивания стен и не дает возможности полноценно мыть стены.',
      replaces: 'Заменяет: покраску, штукатурку, шпаклевку, бамбуковые панели, ЛДСП/МДФ, крашеный ГКЛ',
      steps: ['Стена', 'Грунтовка', 'Штукатурка', 'Шпаклевка', 'Стеклохолст', 'Финишная шпаклевка', 'Покраска'],
      time: 'Отделка штукатуркой 10 000м² за 60 дней'
    },
    gipsovinil: {
      title: 'Инновационный метод отделки стен',
      steps: ['Стена', 'Установка каркаса', 'Монтаж панелей'],
      time: 'Отделка панелями 10 000м² за 30 дней'
    },
    quote: '"ГИПСОВИНИЛ — ЭТО ИНЖЕНЕРНОЕ РЕШЕНИЕ С ПРОДУМАННЫМ ДИЗАЙНОМ И БЕЗУПРЕЧНЫМ СТИЛЕМ, КОТОРОЕ ПРИДАЕТ СТАТУСНЫЙ ВИД ПРОСТРАНСТВУ. ОНО УНИКАЛЬНО, ПОТОМУ ЧТО СДЕЛАНО В КАЗАХСТАНЕ — ДЛЯ КАЗАХСТАНА."',
    quoteAuthor: '— Основатель проекта "Гипсовинил"',
    benefits: [
      { bold: 'РАЗНООБРАЗИЕ ОСНОВ', text: '— для каждого проекта и технического задания' },
      { bold: 'МНОГОФУНКЦИОНАЛЬНАЯ СБОРКА И РАЗБОРКА ПАНЕЛЕЙ', text: '— фрагментальная замена панелей и постоянный доступ к коммуникациям' },
      { bold: 'ВОЗМОЖНОСТЬ МОДУЛЬНОЙ СБОРКИ И ПЕРЕСТРОЙКИ ПЕРЕГОРОДОК', text: '— гибкий интерьер' },
      { bold: 'ВЫСОТА ПАНЕЛЕЙ ДО 3 М', text: '— минимум стыков, максимум эстетики' },
      { bold: 'ЭКСКЛЮЗИВНАЯ АВТОРСКАЯ КОЛЛЕКЦИЯ ЦВЕТОВ,', text: ' адаптированная под восточные вкусы' },
      { bold: 'ЛИНЕЙКА ПО СЕГМЕНТАМ:', text: ' от Бюджета до Luxe — для разных задач и бюджетов' }
    ]
  },
  kz: {
    heading1: 'БІЗ ЖӘНВЛІ ӨНІМ ЖАСАЙМЫЗ ЕМЕС,',
    heading2: 'ЖАҢА ӨҢДЕУ СТАНДАРТЫН ЖАСАЙМЫЗ',
    panelReady: 'Панель бірден орнатуға дайын — теңестірусіз, бояусыз, сылақсыз.',
    traditional: {
      title: 'Дәстүрлі қабырға әрлеу әдісі',
      subtitle: 'Ескірген әдістерге технологиялық балама',
      desc: 'Ылғал процестер жұмыс сапасын ерекше бақылауды талап етеді, әр қабат кептіруге уақыт алады. Ғимарат отыруы кезінде жарықшақтар пайда болуы мүмкін, бояу қабырғаларды үнемі қайта бояуды талап етеді және қабырғаларды толық жууға мүмкіндік бермейді.',
      replaces: 'Алмастырады: бояу, сылақ, шпаклевка, бамбук панельдері, ЛДСП/МДФ',
      steps: ['Қабырға', 'Грунттау', 'Сылақ', 'Шпаклевка', 'Шыны холст', 'Финиш шпаклевка', 'Бояу'],
      time: 'Сылақпен әрлеу 10 000м² 60 күнде'
    },
    gipsovinil: {
      title: 'Қабырға әрлеудің инновациялық әдісі',
      steps: ['Қабырға', 'Каркас орнату', 'Панельдерді монтаждау'],
      time: 'Панельдермен әрлеу 10 000м² 30 күнде'
    },
    quote: '"ГИПСОВИНИЛ — БҰЛ ОЙЛАСТЫРЫЛҒАН ДИЗАЙНЫ МЕН МІНСІЗ СТИЛІ БАР ИНЖЕНЕРЛІК ШЕШІМ. ОЛ КЕҢІСТІККЕ МӘРТЕБЕЛІ КӨРІНІС БЕРЕДІ. ОЛ БІРЕГЕЙ, ӨЙТКЕНІ ҚАЗАҚСТАНДА ЖАСАЛҒАН — ҚАЗАҚСТАН ҮШІН."',
    quoteAuthor: '— "Гипсовинил" жобасының негізін қалаушы',
    benefits: [
      { bold: 'НЕГІЗДЕРДІҢ АЛУАН ТҮРЛІЛІГІ', text: '— әр жоба мен техникалық тапсырма үшін' },
      { bold: 'КӨПФУНКЦИОНАЛДЫ ҚҰРАСТЫРУ ЖӘНЕ БӨЛШЕКТЕУ', text: '— панельдерді фрагменттік ауыстыру және коммуникацияларға тұрақты қол жеткізу' },
      { bold: 'МОДУЛЬДІК ҚҰРАСТЫРУ ЖӘНЕ ҚАЙТА ЖОСПАРЛАУ МҮМКІНДІГІ', text: '— икемді интерьер' },
      { bold: 'ПАНЕЛЬДЕРДІҢ БИІКТІГІ 3 М ДЕЙІН', text: '— минимум жіктер, максимум эстетика' },
      { bold: 'ЭКСКЛЮЗИВТІК АВТОРЛЫҚ ТҮСТЕР КОЛЛЕКЦИЯСЫ,', text: ' шығыс талғамына бейімделген' },
      { bold: 'СЕГМЕНТТЕР БОЙЫНША ЖЕЛІ:', text: ' Бюджеттен Luxe-ке дейін — түрлі міндеттер мен бюджеттер үшін' }
    ]
  },
  en: {
    heading1: "WE DON'T JUST CREATE A PRODUCT,",
    heading2: 'WE SET THE STANDARD FOR NEW FINISHING',
    panelReady: 'Panel is ready for installation immediately — no leveling, painting, plastering, or other wet processes.',
    traditional: {
      title: 'Traditional Wall Finishing Method',
      subtitle: 'Technological alternative to outdated finishing methods',
      desc: 'Wet processes require special quality control, each layer takes time to dry. Building settlement can cause cracks, paint requires regular repainting and does not allow proper wall washing.',
      replaces: 'Replaces: painting, plastering, putty, bamboo panels, LDSP/MDF',
      steps: ['Wall', 'Primer', 'Plaster', 'Putty', 'Fiberglass', 'Finish Putty', 'Painting'],
      time: 'Plastering 10,000m² in 60 days'
    },
    gipsovinil: {
      title: 'Innovative Wall Finishing Method',
      steps: ['Wall', 'Frame installation', 'Panel mounting'],
      time: 'Panel finishing 10,000m² in 30 days'
    },
    quote: '"GIPSOVINIL IS AN ENGINEERING SOLUTION WITH THOUGHTFUL DESIGN AND IMPECCABLE STYLE THAT GIVES A PRESTIGIOUS LOOK TO ANY SPACE. IT IS UNIQUE BECAUSE IT IS MADE IN KAZAKHSTAN — FOR KAZAKHSTAN."',
    quoteAuthor: '— Founder of Gipsovinil Project',
    benefits: [
      { bold: 'VARIETY OF BASES', text: '— for every project and technical requirement' },
      { bold: 'MULTIFUNCTIONAL ASSEMBLY AND DISASSEMBLY', text: '— panel replacement and constant access to utilities' },
      { bold: 'MODULAR ASSEMBLY AND PARTITION RECONFIGURATION', text: '— flexible interior' },
      { bold: 'PANEL HEIGHT UP TO 3 M', text: '— minimum joints, maximum aesthetics' },
      { bold: 'EXCLUSIVE AUTHOR COLOR COLLECTION,', text: ' adapted to Eastern tastes' },
      { bold: 'PRODUCT LINE BY SEGMENTS:', text: ' from Budget to Luxe — for different tasks and budgets' }
    ]
  },
  ar: {
    heading1: 'نحن لا نصنع منتجاً فحسب،',
    heading2: 'بل نضع معياراً جديداً للتشطيبات',
    panelReady: 'اللوح جاهز للتركيب فوراً — دون تسوية أو دهان أو لياسة أو أي عمليات رطبة أخرى.',
    traditional: {
      title: 'الطريقة التقليدية لتشطيب الجدران',
      subtitle: 'بديل تقني لأساليب التشطيب القديمة',
      desc: 'تستلزم العمليات الرطبة رقابة جودة دقيقة، وتستغرق كل طبقة وقتاً للجفاف. قد يتسبب هبوط المبنى في ظهور شقوق، كما يستدعي الدهان إعادة طلاء دورية ولا يتحمل الغسيل المتكرر للجدران.',
      replaces: 'يحل محل: الدهان، اللياسة، المعجون، الألواح الخيزرانية، LDSP/MDF',
      steps: ['الجدار', 'البرايمر', 'اللياسة', 'المعجون', 'الألياف الزجاجية', 'المعجون النهائي', 'الدهان'],
      time: 'تشطيب 10,000م² بالليّاسة في 60 يوماً'
    },
    gipsovinil: {
      title: 'الطريقة المبتكرة لتشطيب الجدران',
      steps: ['الجدار', 'تركيب الهيكل', 'تثبيت الألواح'],
      time: 'تشطيب 10,000م² بالألواح في 30 يوماً'
    },
    quote: '«GIPSOVINIL حل هندسي يجمع بين التصميم المدروس والأناقة المثالية، يمنح كل فضاء طابعاً راقياً ومميزاً. وما يجعله فريداً أنه يُصنع في كازاخستان — لكازاخستان.»',
    quoteAuthor: '— مؤسس مشروع Gipsovinil',
    benefits: [
      { bold: 'تنوع القواعد', text: '— لكل مشروع ومتطلب تقني' },
      { bold: 'تركيب وفك متعدد الوظائف', text: '— إمكانية استبدال الألواح والوصول الدائم إلى الأنظمة المخفية' },
      { bold: 'تجميع معياري وإعادة تهيئة الفواصل', text: '— مرونة في التصميم الداخلي' },
      { bold: 'ارتفاع اللوح يصل إلى 3 م', text: '— حد أدنى من الوصلات وحد أقصى من الجماليات' },
      { bold: 'مجموعة ألوان حصرية من تصميم المؤلف،', text: ' مُكيَّفة مع الأذواق الشرقية' },
      { bold: 'خط منتجات مصنَّف حسب الشرائح:', text: ' من الاقتصادي إلى الفاخر — لمختلف المتطلبات والميزانيات' }
    ]
  }
};

const StandardSection = () => {
  const { language } = useLanguage();
  const t = content[language] || content.ru;

  return (
    <>
      {/* Section 1: Standard of New Finishing */}
      <section className="bg-[#061d36] py-8 md:py-16" data-testid="standard-section">
        <div className="container mx-auto px-4 max-w-7xl">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2 leading-tight text-center">{t.heading1}</h2>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-8 md:mb-12 leading-tight text-center">{t.heading2}</h2>

          <div className="grid md:grid-cols-2 gap-6 md:gap-10 mb-10">
            {/* Traditional method */}
            <div className="bg-white/5 rounded-2xl p-5 md:p-8 border border-white/10 flex flex-col">
              <h3 className="text-xl font-bold text-white/60 mb-4 text-center">{t.traditional.title}</h3>
              <p className="text-white/50 text-sm mb-2 leading-relaxed">Мокрые процессы требуют особого контроля качества работ, каждый слой занимает время на просушку.</p>
              <p className="text-white/50 text-sm mb-6 leading-relaxed">{language === 'kz' ? 'Ғимарат отыруы кезінде жарықшақтар пайда болуы мүмкін, бояу қабырғаларды үнемі қайта бояуды талап етеді және қабырғаларды толық жууға мүмкіндік бермейді.' : language === 'en' ? 'Building settlement can cause cracks, paint requires regular repainting and does not allow proper wall washing.' : 'При усадке здания могут появиться трещины, покраска требует регулярного перекрашивания стен и не дает возможности полноценно мыть стены.'}</p>
              <div className="flex flex-wrap items-center gap-2 mb-6">
                {t.traditional.steps.map((step, i) => (
                  <React.Fragment key={i}>
                    <span className="text-sm text-white/80 bg-white/10 px-3 py-1.5 rounded-lg">{step}</span>
                    {i < t.traditional.steps.length - 1 && <ArrowRight className="w-4 h-4 text-white/30" />}
                  </React.Fragment>
                ))}
              </div>
              <div className="rounded-xl overflow-hidden border border-white/10 mb-6">
                <img src="/uploads/traditional-method.png" alt={t.traditional.title} className="w-full h-auto" loading="lazy" />
              </div>
              <div className="flex-grow" />
              <div className="flex items-center justify-center gap-3 bg-white border border-[#8b4444] rounded-xl px-5 py-3">
                <Clock className="w-5 h-5 text-[#8b4444]" />
                <span className="text-[#061d36] font-bold text-lg">{t.traditional.time}</span>
              </div>
            </div>

            {/* GIPSOVINIL method */}
            <div className="bg-[#F5F5F0] rounded-2xl p-5 md:p-8 border border-[#8b4444]/30 flex flex-col">
              <h3 className="text-xl font-bold text-[#061d36] mb-6 text-center">{t.gipsovinil.title}</h3>
              <p className="text-[#061d36]/70 text-sm mb-2">{t.panelReady}</p>
              <p className="text-[#061d36]/70 text-sm mb-6">{t.traditional.replaces}</p>
              <div className="flex flex-wrap items-center gap-3 mb-8">
                {t.gipsovinil.steps.map((step, i) => (
                  <React.Fragment key={i}>
                    <span className="text-sm text-white font-medium bg-[#8b4444] px-4 py-2 rounded-lg">{step}</span>
                    {i < t.gipsovinil.steps.length - 1 && <ArrowRight className="w-5 h-5 text-[#8b4444]" />}
                  </React.Fragment>
                ))}
              </div>
              <div className="rounded-xl overflow-hidden border border-[#061d36]/10 mb-6">
                <img src="/images/montage_scheme.webp" alt="Mounting scheme" className="w-full h-auto" loading="lazy" />
              </div>
              <div className="flex-grow" />
              <div className="flex items-center justify-center gap-3 bg-[#F5F5F0] border border-[#061d36] rounded-xl px-5 py-3">
                <Clock className="w-5 h-5 text-[#061d36]" />
                <span className="text-[#061d36] font-bold text-lg">{t.gipsovinil.time}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 is moved to HomePage as QuoteBanner */}
      {/* Section 3 (Benefits) is moved to HomePage */}
    </>
  );
};

export default StandardSection;
